import { createFeatureSelector, createSelector } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

import { Organization } from '@core/objects/organization';
import { Settings } from '../settings.state';

export interface SettingsOrganizationActionStatus {
    updateStatus: number;        // Add status for updateOrganization
    uploadStatus: number;        // Add status for uploadLogo
    deleteStatus: number;        // Add status for deleteLogo
}

export interface SettingsOrganization {
    organization: Organization;
    logoResponse: HttpErrorResponse;
    errorActions: HttpErrorResponse;
    actionsStatus: SettingsOrganizationActionStatus
}

export const initialState: SettingsOrganization = {
    organization: null,
    logoResponse: null,
    errorActions: null,
    actionsStatus: {
        updateStatus: 0,             // Initial status
        uploadStatus: 0,             // Initial status
        deleteStatus: 0              // Initial status
    }
};

const settingsFeatureSelector = createFeatureSelector('settings');

const settingsOrganizationStateSelector = createSelector(
    settingsFeatureSelector,
    (state: Settings) => state.organization
);

export const selectErrorActions = createSelector(
    settingsOrganizationStateSelector, 
    (state: SettingsOrganization) => state.errorActions);

export const selectUpdateStatus = createSelector(
    settingsOrganizationStateSelector,
    (state: SettingsOrganization) => state.actionsStatus.updateStatus
);  

export const selectUploadStatus = createSelector(
    settingsOrganizationStateSelector,
    (state: SettingsOrganization) => state.actionsStatus.uploadStatus
);

export const selectDeleteStatus = createSelector(
    settingsOrganizationStateSelector,
    (state: SettingsOrganization) => state.actionsStatus.deleteStatus
);

    